import ApiService from './ApiService';

const ConnectionsService = {
  list: () => ApiService.get('/connections'),
  saveAiKey: (provider, apiKey) => ApiService.put('/connections/ai', { provider, apiKey }),
  saveStoreKey: (apiKey, storeId) => ApiService.put('/connections/estore', { apiKey, storeId }),
  saveAnalyticsKey: (apiKey) => ApiService.put('/connections/analytics', { apiKey }),
  saveWhatsappKey: (apiKey) => ApiService.put('/connections/whatsapp', { apiKey }),
  saveOrkaToken: (token) => ApiService.put('/connections/orka', { token }),
  remove: (id) => ApiService.del(`/connections/${id}`),
};

export default ConnectionsService;
